import { TrainingsContentBlockInput } from 'generated/resources/graphql'

import { AttachedFile } from 'modules/trainings/lib/content/AttachedFile'
import { VideoBlock } from 'modules/trainings/lib/content/VideoBlock'
import { BlockMapper } from 'modules/trainings/lib/content/mappers/graphql/BlockMapperRegistry'
import { MapperTransformationError } from 'modules/trainings/lib/content/mappers/graphql/errors'
import { GQLContentBlock } from 'modules/trainings/lib/content/mappers/graphql/types'

function isVideoContentable(
  contentable: GQLContentBlock['contentable']
): contentable is NonNullable<GQLContentBlock['contentable']> & {
  __typename: 'TrainingsContentBlockVideo'
  video?: { url?: string | null; filename?: string | null } | null
} {
  return contentable?.__typename === 'TrainingsContentBlockVideo'
}

export const videoBlockMapper: BlockMapper<VideoBlock> = {
  graphqlTypename: 'TrainingsContentBlockVideo',
  blockConstructor: VideoBlock,

  fromGraphQL(gqlBlock: GQLContentBlock): VideoBlock {
    const contentable = gqlBlock.contentable
    const typename = contentable?.__typename

    if (!isVideoContentable(contentable)) {
      throw new MapperTransformationError(
        'TrainingsContentBlockVideo',
        `Expected TrainingsContentBlockVideo, got ${typename || 'null'}`,
        gqlBlock
      )
    }

    return new VideoBlock({
      id: gqlBlock.id,
      uuid: gqlBlock.uuid,
      title: gqlBlock.title,
      accesible: gqlBlock.accesible,
      status: gqlBlock.status,
      video: new AttachedFile({
        url: contentable.video?.url || undefined,
        filename: contentable.video?.filename || undefined,
      }),
    })
  },

  toGraphQL(block: VideoBlock): TrainingsContentBlockInput {
    return {
      uuid: block.uuid,
      title: block.title,
      type: 'video',
      typeVideo: {
        video: {
          signedId: block.video.signedId,
          url: block.video.url,
        },
      },
    }
  },
}
